import { render, staticRenderFns } from "./ConsentCheckbox.vue?vue&type=template&id=d2a82caa&scoped=true"
import script from "./ConsentCheckbox.vue?vue&type=script&lang=js"
export * from "./ConsentCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ConsentCheckbox.vue?vue&type=style&index=0&id=d2a82caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a82caa",
  null
  
)

export default component.exports